import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import './SubscriptionStyles.css'; // Reuse or create specific styles

const BankInstructionsPage = () => {
    const { isDark } = useTheme();
    
    // Replace with actual bank details
    const bankDetails = {
        recipientName: "IME FIRME",
        svrha: "UPLATA PAKETA",
        primalac: "TRUSTAI d.o.o.", // Example: Use user's OIB and date, or generate a unique reference
        racunPrimaocao: "1610000367080021",
        iznos: "Cijena paketa", // Or dynamically fetch based on selected plan
    };

    return (
        <div className={`bank-instructions-container ${isDark ? 'bank-instructions-inverted' : ''}`}>
            <h2>Podaci za uplatu putem banke</h2>
            <p>Molimo vas da izvršite uplatu koristeći sljedeće podatke. Vaša pretplata će biti aktivirana ručno unutar 24-48 sati nakon što evidentiramo vašu uplatu.</p>
            
            <div className="instructions-box">
                <p><strong>Uplatio je:</strong> {bankDetails.recipientName}</p>
                <p><strong>Svrha doznake:</strong> {bankDetails.svrha}</p>
                <p><strong>Primalac:</strong> {bankDetails.primalac}</p>
                <p><strong>Račun primaoca:</strong> {bankDetails.racunPrimaocao}</p>
                <p><strong>Iznos:</strong> {bankDetails.iznos}</p>
            </div>

            <p><strong>Važna napomena:</strong> Kako bismo što brže povezali vašu uplatu s vašim računom, ključno je da točno unesete <strong>Poziv na broj primatelja</strong>.</p>
            
            <p>Ako imate bilo kakvih pitanja, slobodno nas kontaktirajte.</p>

            <Link to="/app/chat" className="button-link">
                Povratak na Chat
            </Link>
        </div>
    );
};

export default BankInstructionsPage;

